import React from 'react';

export const ConstructionPlanFormModelEditHint = () => (
    <div className="construction-plan-form__edit-hint">
        Konfiguration angepasst
    </div>
);

export default ConstructionPlanFormModelEditHint;
